import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { productServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const productInstance = axios.create({
  baseURL: productServiceUrl,
  headers,
})

productInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

productInstance.interceptors.response.use(response => response, error => {
  return responseInterceptor(error)
})

export default productInstance
